import _ from 'lodash';
import {connect} from 'react-redux';

import {BannerTypesEnum} from '../../../../libs/shared/core/src/store/banners/commonBannerState';
import {InfoBannerTypesEnum} from '../../../../libs/shared/core/src/store/banners/commonBannerTypes';
import {AppPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  AppParametricSelector,
  createShallowEqualSelector,
  makeMapStateToProps,
} from '../../../../srcCommon/helpers/reselectHelpers';
import {makeGetVisibleBannersForPanel} from '../../../store/panels/app/banners/bannersSelectors';
import {VoiceBannerState} from '../../../store/panels/app/banners/bannersState';
import {VoiceBanners} from './voiceBanners';

/*
 * Props.
 */

interface VoiceBannersContainerProps {
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

type VoiceBannersSelector = AppParametricSelector<
  VoiceBannersContainerProps,
  ReadonlyArray<VoiceBannerState>
>;

function makeGetBanners(): VoiceBannersSelector {
  return createShallowEqualSelector([makeGetVisibleBannersForPanel()], (visibleBanners) =>
    _(visibleBanners)
      .map((banner) => {
        if (banner.type === BannerTypesEnum.INFO && banner.infoType === InfoBannerTypesEnum.VOICE) {
          return banner;
        }

        return undefined;
      })
      .compact()
      .value(),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<VoiceBannersContainerProps>()(() => ({
  banners: makeGetBanners(),
}));

export const VoiceBannersContainer = connect(mapStateToProps)(VoiceBanners);
